module.exports = __webpack_public_path__ + "img/1_louis.5e5fde1a.jpg";